export const ErrorMsg = {
    REQERR: {
      status_code: -1,
      data: [],
      status_msg: "请求失败"
    }
  };
  